import React from 'react'
import ic_checked from '../../assets/images/ic_check_white.png'
import WizImage from '../image/WizImage'

interface IProps {
    className?: string
    children?: any
    onClick?: () => void
    onChecked?: (e?: any) => void
    checked?: boolean
}

const CheckTableItem: React.FC<IProps> = ({className, children, onClick, onChecked, checked = false}) => {
    return (
        <div className={'relative'}>
            <label>
                <div
                    className={`absolute top-[50%] left-[10px] transform translate-y-[-50%] w-[15px] h-[15px] rounded-[2px] cursor-pointer ${
                        checked ? 'bg-primary' : 'bg-white border border-line01 '
                    }`}>
                    {checked && <WizImage src={ic_checked} className={'w-full'} />}
                </div>
                <input
                    onChange={() => {
                        onChecked && onChecked()
                    }}
                    type={'checkbox'}
                    className={'hidden'}
                />
            </label>

            <div
                onClick={onClick}
                className={`flex-1 grid pl-[40px] pr-[30px] py-[20px] gap-[20px] items-center border-b hover:bg-bg_green cursor-pointer  ${className}`}>
                {children}
            </div>
        </div>
    )
}

export default CheckTableItem
